module.exports = __webpack_public_path__ + "static/media/icon-edit-simple.f256ba95.svg";